import React from 'react';
import { Img } from 'react-image';

const FloatingCompany = () => {
	const data = [
		[
			'/assets/smallcase_logo.svg',
			'/assets/dream11_logo.svg',
			'/assets/airmeet_logo.svg',
			'/assets/IBM_logo.svg',
			'/assets/Ajio_logo.svg',
			'/assets/salesken_logo.svg',
		],
		[
			'/assets/urban_piper.svg',
			'/assets/cap_gemini.svg',
			'/assets/pagar_book.svg',
			'/assets/vyapar_logo.svg',
			'/assets/swiggy_logo.svg',
			'/assets/bharatPe_logo.svg',
		],
		[
			'/assets/ola.svg',
			'/assets/leap_finance.svg',
			'/assets/BharatAgri_logo.svg',
			'/assets/shareChat_logo.svg',
			'/assets/eatFit_logo.svg',
			'/assets/home_lane.svg',
		],
	];
	return (
		<div className="m-auto box-border flex max-w-[90%] flex-col gap-2 ">
			{data.map((marquee, index) => (
				<div key={index} className="m-auto mx-2">
					<ul className={index % 2 === 0 ? 'marquee-content' : 'marquee-content_left_to_right'}>
						{marquee.map((imgUrl, imgIndex) => (
							<li key={imgIndex}>
								<Img className="md:rounded-xl sm:rounded-s" src={imgUrl} width="188" height="104" alt={imgUrl} />
							</li>
						))}
					</ul>
				</div>
			))}
		</div>
	);
};

export default FloatingCompany;
